import React from 'react'
import { Box, Typography, Paper, Button, Rating, Grid, useMediaQuery } from '@mui/material';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ArrowBack, ArrowForward, FormatQuote } from '@mui/icons-material';

function Testimonial() {
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow: !isSmallScreen ? <ArrowBack sx={{ color: 'inherit' }} /> : null,
        nextArrow: !isSmallScreen ? <ArrowForward sx={{ color: 'inherit' }} /> : null,
    };

    const images = [
        {
            name: 'Elixir Global',
            imgPath:
                'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80',
            review: 'Sidul is very talented seller He done my complex referral system in few day only , i ll definitely come soon again with new work Thanks'
        },
        {
            name: 'Axiom Ventures',
            imgPath:
                'https://images.unsplash.com/photo-1566753323558-f4e0952af115?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1021&q=80',
            review: 'Working with Sidul was a game-changer for my project. Their expertise and dedication brought my vision to life, and the end result exceeded all expectations. I\'m truly grateful for their professionalism and creative insights.'
        },
        {
            name: 'Olivia Müller',
            imgPath:
                'https://images.unsplash.com/photo-1605794432120-f4bb5dc9067d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1287&q=80',
            review: 'I can\'t thank Sidul enough for their outstanding work. Their attention to detail and commitment to excellence are evident in every aspect of the project. I highly recommend their services to anyone seeking top-notch web development.'
        },
        {
            name: 'William Ng',
            imgPath:
                'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
            review: 'Collaborating with Sidul was an absolute pleasure. Their ability to understand my needs and translate them into a seamless user experience is unmatched. I\'m thrilled with the final product and look forward to future collaborations.'
        },
    ];

    return (
        <Box component={"div"} id='testimonial' py={5}>
            <Typography variant='h3' sx={{ fontWeight: "700" }} textAlign="center" width={330} borderBottom="1px solid" borderColor={"primary"} color="primary" m="auto" mb={5}>Testimonial</Typography>
            <Box display={"flex"} justifyContent={"center"} alignItems={"center"} px={2}>
                <Box sx={{ maxWidth: isSmallScreen ? "310px" : "600px", flexGrow: 1 }}>
                    <Paper elevation={2}>
                        <Slider {...settings}>
                            {images.map((step, index) => (
                                <Box component={"div"} key={index} sx={{
                                    display
                                        : "flex !important", justifyContent: "center", alignItems: "center", flexDirection: "column"
                                }}>
                                    <Grid container justifyContent={"center"} alignItems={"center"} gap={2} mt={2}>
                                        <Grid
                                            item
                                            lg={1}
                                            component="img"
                                            sx={{
                                                height: "50px",
                                                display: 'block',
                                                width: "50px",
                                                overflow: 'hidden',
                                                borderRadius: "50%",
                                                objectFit: "cover"
                                            }}
                                            src={step.imgPath}
                                            alt={step.name}
                                        />
                                        <Grid item>
                                            <Typography variant='h5' sx={{ fontWeight: "600" }}>{step.name}</Typography>
                                            <Rating value={5} readOnly size='small' />
                                        </Grid>
                                    </Grid>
                                    <Box sx={{ textAlign: 'center', padding: 0 }}>
                                        <FormatQuote sx={{ fontSize: '2rem', marginBottom: '0.5rem', color: '#888', transform: "rotateY(180deg) rotateX(180deg)" }} />
                                        <Typography variant="body1" mx={1} sx={{ fontStyle: 'italic'}}>
                                            "{step.review}"
                                        </Typography>
                                        <FormatQuote sx={{ fontSize: '2rem', marginTop: '0.5rem', color: '#888' }} />
                                    </Box>
                                </Box>
                            ))}
                        </Slider>
                    </Paper>
                </Box>
            </Box>
        </Box>
    )
}

export default Testimonial